import { createSSRApp } from 'vue'
import App from './App.vue'
import { prototypeInterceptor, requestInterceptor, routeInterceptor } from './interceptors'
import { setupStore } from '/@/store'
import '/@/style/index.scss'
import '/@/style/theme.scss'; 

// #ifdef H5
// import Vconsole from 'vconsole'
// new Vconsole()
// #endif

export function createApp() {
  const app = createSSRApp(App)

  setupStore(app)

  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  return {
    app,
  }
}
